<section id="impacto" class="about-industries dingo-section dingo-bg-base">
  <div class="container">
    <div class="about-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <p class="about-kicker">Sectores en los que trabajamos</p>
      <h2 class="about-section-title">
        Industrias donde generamos <span class="highlight-green">impacto real</span>
      </h2>
      <p class="about-section-desc">
        Adaptamos estrategia, creatividad, medios y medición al contexto comercial de cada industria.
      </p>
    </div>

    <div class="about-industry-grid">
      @for (industry of industries; track industry.title; let i = $index) {
      <article class="about-industry-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i % 3">
        <div class="about-industry-icon">
          <i class="bi {{ industry.icon }}"></i>
        </div>
        <h3>{{ industry.title }}</h3>
        <p>{{ industry.description }}</p>
      </article>
      }
    </div>
  </div>
</section>
